import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Sizes & Prices',
  name: 'sizesPrices',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'Sizes & Prices',
    }),
    defineField({
      title: 'Tables',
      name: 'tables',
      type: 'array',
      of: [{ type: 'sizeTable' }],
    }),
  ],
})